import {Injectable} from '@angular/core';
import {LoginService} from '../../shared/services/login.service';
import {FileUploadService} from '../../shared/services/file-upload.service';
import {HttpClient} from '@angular/common/http';
import {CmpService} from './cmp.service';


@Injectable()
export class CmpNfService extends CmpService {
  constructor(protected http: HttpClient, protected loginService: LoginService, protected fileUploadService: FileUploadService) {
    super(http, loginService, fileUploadService);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/cmp-nf.service.ts